import { trackEvent } from '@host/utils/posthog-track';

export type RecordingStopReason = 'user' | 'time_limit' | 'left_room' | 'initiator_absent';

export type TranscriptionStopReason =
  'user' | 'left_room' | 'recording_started' | 'initiator_absent';

const secondsSince = (start?: string | Date | null) =>
  start ? Math.round((Date.now() - new Date(start).getTime()) / 1000) : null;

export const trackRecordingStarted = (props: {
  withTranscript: boolean;
  participantCount: number;
  replacedTranscription: boolean;
}) => {
  trackEvent('recording_started', {
    with_transcript: props.withTranscript,
    participant_count: props.participantCount,
    replaced_transcription: props.replacedTranscription,
  });
};

export const trackRecordingStopped = (
  stopReason: RecordingStopReason,
  recording: { recordingStartTime?: string; can_transcribe?: boolean } | null
) => {
  trackEvent('recording_stopped', {
    stop_reason: stopReason,
    with_transcript: !!recording?.can_transcribe,
    duration_seconds: secondsSince(recording?.recordingStartTime),
  });
};

export const trackTranscriptionStarted = (
  mode: 'standalone' | 'added_to_recording',
  participantCount: number
) => {
  trackEvent('transcription_started', { mode, participant_count: participantCount });
};

export const trackTranscriptionStopped = (
  stopReason: TranscriptionStopReason,
  startedAt: string | Date | null | undefined
) => {
  trackEvent('transcription_stopped', {
    stop_reason: stopReason,
    duration_seconds: secondsSince(startedAt),
  });
};
